import { useCallback, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { M_Button } from "src/M_Components/M_Button/M_Button"
import { M_MessageBoard } from "src/M_Components/M_MessageBoard/M_MessageBoard"

export const LeavingPageModal = ({
    open,
    onConfirm,
    onClose
}) => {
    const { t } = useTranslation()

    const handleClose = useCallback(() => {
        if (onClose) {
            onClose()
        }
    }, [onClose])

    const handleConfirm = useCallback(async () => {
        if (onConfirm) {
            await Promise.resolve(onConfirm())
        }

        handleClose()
    }, [handleClose, onConfirm])

    return (
        <M_MessageBoard
            warning
            open={open}
            onClose={handleClose}
            title={t("leavingPageTitle")}
            body={t("leavingPageBodyRead")}
            footer={
                <span style={{ display: "flex", alignItems: "center" }}>
                    <M_Button hoverEffect normal labelColor={"white"} backgroundColor={"var(--color-red)"} onClick={handleClose} label={t("ButtonCancel")} />
                    <M_Button hoverEffect normal labelColor={"white"} backgroundColor={"var(--color-green)"} onClick={handleConfirm} label={t("ButtonConfirm")} />
                </span>
            }
        />
    )
}

export const useLeavingPageModal = () => {
    const [state, setState] = useState({
        open: false,
        onConfirm: null
    })

    const closeLeavingModal = useCallback(() => {
        setState({ open: false, onConfirm: null })
    }, [])

    const openLeavingModal = useCallback((onConfirm) => {
        setState({ open: true, onConfirm: onConfirm || null })
    }, [])

    const handleConfirm = useCallback(async () => {
        if (state.onConfirm) {
            await Promise.resolve(state.onConfirm())
        }
        closeLeavingModal()
    }, [closeLeavingModal, state.onConfirm])

    const leavingModalProps = useMemo(() => ({
        open: state.open,
        onClose: closeLeavingModal,
        onConfirm: handleConfirm
    }), [closeLeavingModal, handleConfirm, state.open])

    return {
        openLeavingModal,
        closeLeavingModal,
        leavingModalProps
    }
}
